module.exports = __webpack_public_path__ + "assets/8c88975cc29d1f5cba73d6083ae8b58d.mp4";